// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608092356/js/" + chunkId + "." + {"44":"b8b48183","225":"3e0fcf48","481":"23b62e86","486":"586dfcfd","770":"d4970fc7"}[chunkId] + ".0.6224289674585044.chunk.js";
};